/**
 * Route names for the CareSend Portal across apps.
 */
var PortalRouteName;
(function (PortalRouteName) {
    PortalRouteName["ROOT"] = "Root";
    /**
     * Itinerary and Orders are the only routes with conflicting names
     * TODO: Refactor to remove conflict
     */
    PortalRouteName["ITINERARY"] = "PortalItinerary";
    PortalRouteName["JOBS"] = "Jobs";
    PortalRouteName["JOB_DETAILS"] = "JobDetails";
    PortalRouteName["ORDERS"] = "PortalOrders";
    PortalRouteName["PROCEDURE"] = "Procedure";
    PortalRouteName["SHIFT_CANCELATION_PATIENT_DOB"] = "ShiftCancelationPatientDOB";
})(PortalRouteName || (PortalRouteName = {}));

export { PortalRouteName };
